Vue.component('content-spartacus-lab', {
    delimiters: ['[[', ']]'],
    template: `
        <div id="contentSpartacusLab" class="lqd-modal lity-hide">
            <div class="lqd-modal-inner">

                <div class="lqd-modal-head"></div>

                <div class="lqd-modal-content">
                    <div class="row">
                        <div class="lqd-column col-md-12 px-4 pt-45 pb-30">
                            <div class="row d-flex flex-wrap align-items-center">
                                <div class="lqd-column col-md-6 col-md-offset-1">
                                    <header class="fancy-title">
                                        <h3>Spartacus Lab SARL</h3>
                                    </header>
                                </div>
                            </div>
                        </div>
                        <div class="lqd-column col-md-10 col-md-offset-1" style='margin-top:-20px;'>
                            <p>Spartacus Lab SARL was founded in Switzerland in 2020 and owns the <span class="sq-font" style='color:black;'>SpartaQuant</span> project</p>
                        </div>
                        <br>
                    </div>
                </div>
                <div class="lqd-modal-foot"></div>
            </div>
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {

        }
    },
    mounted(){

    },
    methods: {
        
    },
});

